export default function Loader({ label = "Loading", fullPage = false }) {
  return (
    <div className={`loader ${fullPage ? "is-full" : ""}`} role="status">
      <span className="loader-spinner" aria-hidden="true" />
      <span>{label}</span>
    </div>
  );
}

export function ErrorState({ message, onRetry }) {
  return (
    <div className="error-state" role="alert">
      <p>{message}</p>
      {onRetry && (
        <button type="button" className="btn btn-secondary btn-sm" onClick={onRetry}>Try again</button>
      )}
    </div>
  );
}
